import { render, staticRenderFns } from "./Datagraph5_Copy.vue?vue&type=template&id=23cf4ed1&scoped=true"
import script from "./Datagraph5_Copy.vue?vue&type=script&lang=js"
export * from "./Datagraph5_Copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cf4ed1",
  null
  
)

export default component.exports